module.exports = __webpack_public_path__ + "static/media/Artboard4.be2c33ea.png";